module.exports = "/_next/static/images/how-bounty-works-c6ab072fb8f5e2428a600f17c2d72abb.png";